module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "faq-component"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "faq-content"
  }, [_c('el-collapse', {
    attrs: {
      "accordion": ""
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "name": "0"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('div', {
    staticClass: "faq-content-title-wrapper"
  }, [_c('div', {
    staticClass: "faq-icon-wrapper"
  }, [(!_vm.collapses[0]) ? _c('plus-icon', {
    staticClass: "faq-icon"
  }) : _c('minus-icon', {
    staticClass: "faq-icon"
  })], 1), _vm._v(" "), _c('h2', [_vm._v("Consistency")])])]), _vm._v(" "), _c('div', {
    staticClass: "faq-description"
  }, [_c('p', [_vm._v("Consistent with real life: in line with the process and logic of real life, and comply with languages and habits that the users are used to;")])])], 2), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "name": "1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('div', {
    staticClass: "faq-content-title-wrapper"
  }, [_c('div', {
    staticClass: "faq-icon-wrapper"
  }, [(!_vm.collapses[1]) ? _c('plus-icon', {
    staticClass: "faq-icon"
  }) : _c('minus-icon', {
    staticClass: "faq-icon"
  })], 1), _vm._v(" "), _c('h2', [_vm._v("Feedback")])])]), _vm._v(" "), _c('div', {
    staticClass: "faq-description"
  }, [_c('p', [_vm._v("Operation feedback: enable the users to clearly perceive their operations by style updates and interactive effects")])])], 2), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "name": "2"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('div', {
    staticClass: "faq-content-title-wrapper"
  }, [_c('div', {
    staticClass: "faq-icon-wrapper"
  }, [(!_vm.collapses[2]) ? _c('plus-icon', {
    staticClass: "faq-icon"
  }) : _c('minus-icon', {
    staticClass: "faq-icon"
  })], 1), _vm._v(" "), _c('h2', [_vm._v("Efficiency")])])]), _vm._v(" "), _c('div', {
    staticClass: "faq-description"
  }, [_c('p', [_vm._v("Simplify the process: keep operating process simple and intuitive")])])], 2)], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "faq-header"
  }, [_c('h1', [_vm._v("Questions? Look here")]), _vm._v(" "), _c('h5', [_vm._v("Can't find an answer? Chat us")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-551a1543","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Faq.vue
// module id = 1180
// module chunks = 10